import loopback from "@/services/loopback";
import modelObject from "@/services/lb.services";

modelObject.setModel("Logs");

const Logs = Object.assign(
  {},
  {
    relation: "",

    getLogs(params) {
      return loopback.get("/Logs/getAdminLogs", { params });
    },

    activityListing(params) {
      return loopback.get("/Logs/activityListing", { params });
    }
  },
  modelObject
);

export default Logs;
